import React from 'react';
import { useState, useEffect } from 'react';

const sizeOptions = [
	{ value: 'Small' },
	{ value: 'Medium' },
	{ value: 'Large' },
	{ value: 'Giant' },
	{ value: 'Collector' },
	{ value: 'Exhibition' },
];

const frameOptions = [
	{ value: 'Black', style: { backgroundColor: 'black' } },
	{ value: 'White', style: { backgroundColor: 'white' } },
	{
		value: 'Natural Wood',
		style: {
			backgroundImage:
				'url(https://cdn.shopify.com/s/files/1/0115/7385/4270/files/hickory_swatch.jpg?v=1739797322)',
		},
	},
	{ value: 'No Frame', style: { backgroundColor: 'transparent' } },
];

const mountOptions = [{ value: 'Border' }, { value: 'Full Bleed' }];

function ARDrawerContent({
	handleClose,
	variants,
	title,
	handle,
	vendor,
	template,
	arAssets,
	location,
}) {
	const [selectedVariant, setSelectedVariant] = useState({});
	const [activeOptions, setActiveOptions] = useState({
		size: 'Small',
		frame: 'Black',
		mount: 'Border',
	});

	useEffect(() => {
		const { searchParams } = new URL(window.location.href);
		const currentlySelectedID = searchParams.get('variant');

		if (currentlySelectedID) {
			const currentVariant =
				variants.find(
					(variant) => variant.id === Number(currentlySelectedID)
				) || variants[0];

			setActiveOptions({
				size: currentVariant.option1,
				frame: currentVariant.option2,
				mount: currentVariant.option3,
			});
			setSelectedVariant({ ...currentVariant });
		} else {
			setSelectedVariant({ ...variants[0] });
		}
	}, []);

	useEffect(() => {
		const currentVariant =
			variants.find(
				(variant) =>
					variant?.option1 === activeOptions.size &&
					variant?.option2 === activeOptions.frame &&
					variant?.option3 === activeOptions.mount
			) || variants[0];

		setSelectedVariant({ ...currentVariant });
	}, [activeOptions]);

	const handleChange = (event) => {
		const { name, value } = event.target;
		const formattedKey = name.replace('react-', '');

		if (value === 'No Frame') {
			setActiveOptions((prev) => ({
				...prev,
				mount: 'Border',
			}));
		}

		setActiveOptions((prev) => ({
			...prev,
			[formattedKey]: value,
		}));
	};

	const getCurrentARModelLink = () => {
		const currentARAsset =
			arAssets.find(
				(asset) =>
					asset?.id === `gid://shopify/ProductVariant/${selectedVariant.id}`
			) || arAssets[0];

		const isIOSDevice = navigator.userAgent.match(/(iPhone|iPod|iPad)/i);

		return isIOSDevice
			? `${currentARAsset?.usdz_link}#custom=https://houseofspoils.com/products/${handle}?view=ar-overlay#variant=${selectedVariant.id}`
			: `intent://arvr.google.com/scene-viewer/1.0?file=${currentARAsset?.glb_link}&mode=ar_preferred&enable_vertical_placement=true#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://houseofspoils.com/products/${handle};end;"`;
	};

	const getCurrentDimensions = (size) => {
		const variantOrientation =
			selectedVariant?.featured_media?.preview_image?.aspect_ratio > 1
				? 'Horizontal'
				: 'Vertical';

		const variantMountType =
			activeOptions.mount === 'Border' ? 'Mount' : 'Full Bleed';

		return productDimensionsMeta[variantOrientation][variantMountType][size]
			.Final;
	};

	return (
		<div className="tw-max-w-md tw-mx-auto tw-grid tw-gap-5 tw-not-sr-only">
			<div className="tw-grid tw-gap-2">
				<p className="tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal">
					Print
				</p>
				<div className="tw-flex tw-items-center tw-gap-3 tw-bg-gray-200 tw-border tw-border-solid tw-border-steam tw-p-1 tw-rounded-md">
					<div className="tw-h-12 tw-w-12">
						<img
							className="main-product-section-image data-[activeOptions=false]:tw-hidden tw-min-h-full"
							src={
								selectedVariant?.featured_image?.src
									? `${selectedVariant?.featured_image?.src}&width=100`
									: variants[0]?.featured_image?.src
							}
							alt={
								selectedVariant?.featured_image?.alt
									? selectedVariant?.featured_image?.alt
									: variants[0]?.featured_image?.alt
							}
							width={selectedVariant?.featured_image?.width}
							height={selectedVariant?.featured_image?.height}
							loading="eager"
						></img>
					</div>
					<div className="tw-grid tw-gap-1">
						<p className="tw-tracking-1 tw-text-sm tw-uppercase tw-font-sans tw-font-medium">
							{title ? title : ''}
						</p>
						<p className="tw-text-xs/none">by {vendor ? vendor : ''}</p>
					</div>
				</div>
			</div>

			<div className="tw-grid tw-gap-2">
				<p className="tw-flex tw-gap-3 tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal">
					Size
					<span className="tw-pt-1 tw-text-charcoal tw-text-sm/none tw-italic tw-font-serif tw-font-normal tw-tracking-normal tw-normal-case">
						{activeOptions.size}
					</span>
				</p>
				<div className="tw-grid tw-grid-cols-2 tw-gap-2 !tw-mb-0">
					{sizeOptions.map(({ value }) => (
						<div className="tw-flex" key={value}>
							<input
								id={`size-selector-${value}-AR-Drawer`}
								className="disabled:tw-pointer-events-none tw-peer tw-w-0 tw-h-0"
								type="radio"
								name="react-size"
								value={value}
								checked={activeOptions.size === value}
								onChange={handleChange}
							/>
							<label
								htmlFor={`size-selector-${value}-AR-Drawer`}
								className={`tw-w-full tw-flex tw-p-2.5 tw-border tw-border-solid tw-border-steam aria-disabled:tw-pointer-events-none tw-justify-between ${
									activeOptions.size === value
										? 'peer-checked:tw-border-black'
										: ''
								}`}
							>
								<div className="tw-tracking-1 tw-text-sm tw-uppercase tw-font-sans tw-font-medium">
									{value}
								</div>
								<div className="tw-mt-1 tw-text-charcoal tw-text-xs/none tw-italic tw-font-serif">
									{getCurrentDimensions(value)}
								</div>
							</label>
						</div>
					))}
				</div>
			</div>
			<div className="tw-grid tw-gap-2">
				<p className="tw-flex tw-gap-3 tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal">
					Frame
					<span className="tw-pt-1 tw-text-charcoal tw-text-sm/none tw-italic tw-font-serif tw-font-normal tw-tracking-normal tw-normal-case">
						{activeOptions.frame}
					</span>
				</p>
				<div className="tw-flex tw-gap-3">
					{frameOptions.map(({ value, style }) => (
						<div className="tw-flex" key={value}>
							<input
								id={`frame-selector-${value}-AR-Drawer`}
								className="main-product-section-frame-selector-input"
								type="radio"
								name="react-frame"
								value={value}
								checked={activeOptions.frame === value}
								onChange={handleChange}
							/>
							<label
								htmlFor={`frame-selector-${value}-AR-Drawer`}
								className="main-product-section-frame-selector-swatch-label !tw-p-1"
							>
								<div
									className={`main-product-section-frame-selector-swatch ${value
										.toLowerCase()
										.replace(' ', '-')}`}
									style={style}
								/>
							</label>
						</div>
					))}
				</div>
			</div>
			<div className="tw-grid tw-gap-2">
				<p className="tw-flex tw-gap-3 tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal">
					Mount
					<span className="tw-pt-1 tw-text-charcoal tw-text-sm/none tw-italic tw-font-serif tw-font-normal tw-tracking-normal tw-normal-case">
						{activeOptions.mount}
					</span>
				</p>
				<div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-0">
					{mountOptions.map(({ value }) => (
						<div key={value} className="tw-flex tw-w-full">
							<input
								id={`mount-selector-${value}-AR-Drawer`}
								className="main-product-section-mount-selector-input tw-invisible tw-peer tw-sr-only"
								type="radio"
								name="react-mount"
								value={value}
								checked={activeOptions.mount === value}
								onChange={handleChange}
								disabled={activeOptions.frame === 'No Frame'}
							/>
							<label
								htmlFor={`mount-selector-${value}-AR-Drawer`}
								className={`peer-checked:tw-border-black !tw-w-full tw-p-2.5 tw-border tw-border-solid tw-border-steam tw-font-normal tw-text-black tw-cursor-pointer tw-text-center tw-text-sm tw-font-sans tw-tracking-1 tw-uppercase ${
									value === 'Full Bleed' ? 'peer-disabled:tw-text-charcoal' : ''
								}`}
							>
								{value}
							</label>
						</div>
					))}
				</div>
			</div>
			<div className="tw-grid tw-gap-3">
				<a
					id="AR-Drawer-Button"
					className="tw-w-full tw-bg-charcoal-dark tw-p-4"
					href={getCurrentARModelLink()}
					rel="ar"
					type="button"
					onClick={() =>
						sendTrackingEvents('View In Your Space Click', {
							event_detail: selectedVariant?.name,
							event_detail2: `AR Drawer in - ${location}`,
						})
					}
				>
					<picture className="tw-flex tw-justify-center tw-items-center tw-gap-2">
						<svg
							className="tw-w-4 tw-h-4"
							xmlns="http://www.w3.org/2000/svg"
							width="22"
							height="22"
							viewBox="0 0 22 22"
							fill="none"
						>
							<path
								d="M1 3.5V1H3.5"
								stroke="#fff"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M18.5 1L21 1L21 3.5"
								stroke="#fff"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M21 18.5L21 21L18.5 21"
								stroke="#fff"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M3.5 21L1 21L1 18.5"
								stroke="#fff"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M3.5 6.625L11 2.25L18.5 6.625V15.375L11 19.75L3.5 15.375V6.625Z"
								stroke="#fff"
								strokeLinejoin="round"
							/>
							<path
								d="M3.5 7.25L11 11.4167M18.5 7.25L11 11.4167M11 11.4167V19.75"
								stroke="#fff"
								strokeLinejoin="round"
							/>
							<path
								d="M3.5 15.375L8.5 12.25M18.5 15.375L13.5 12.25"
								stroke="#fff"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						<span className="tw-text-white tw-font-sans tw-tracking-1 tw-uppercase tw-text-sm/none">
							View In Your Space
						</span>
					</picture>
				</a>
				<button
					onClick={() => {
						template === 'product'
							? handleClose()
							: handleClose(
									`/products/${handle}?variant=${selectedVariant.id}`
							  );
					}}
					className="tw-text-black tw-text-sm/none tw-text-center tw-cursor-pointer tw-place-self-center tw-w-fit tw-no-underline tw-border-b tw-border-solid tw-border-black tw-py-1"
				>
					{template === 'product' ? 'Back to Product' : 'View Full Details'}
				</button>
			</div>
		</div>
	);
}

export default ARDrawerContent;
